import { render, staticRenderFns } from "./PlayerInventory.vue?vue&type=template&id=1e23212d&scoped=true&"
import script from "./PlayerInventory.vue?vue&type=script&lang=js&"
export * from "./PlayerInventory.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInventory.vue?vue&type=style&index=0&id=1e23212d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23212d",
  null
  
)

export default component.exports